// src/services/instances/championship.ts
import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetChampionshipResponse,
  PostChampionshipResponse,
  GetChampionshipByIdResponse,
  PutChampionshipResponse,
} from '../response/championship';
import { PostChampionshipRequest, PutChampionshipRequest } from '../request/championship';

export class ChampionshipService {
  static getChampionships(params?: QueryParams) {
    return apiClient.get<GetChampionshipResponse>(buildApiUrl('/api/v1/competitions/championships'), params);
  }

  static postChampionship(data: PostChampionshipRequest) {
    return apiClient.post<PostChampionshipResponse>(buildApiUrl('/api/v1/competitions/championships'), data);
  }

  static getChampionshipById(id: string) {
    return apiClient.get<GetChampionshipByIdResponse>(buildApiUrl('/api/v1/competitions/championships/:id', { id }), undefined);
  }

  static putChampionship(id: string, data: PutChampionshipRequest) {
    return apiClient.update<PutChampionshipResponse>(buildApiUrl('/api/v1/competitions/championships/:id', { id }), data);
  }

  static deleteChampionship(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/competitions/championships/:id', { id }), undefined);
  }
}
